import { render, staticRenderFns } from "./ModifierItem.vue?vue&type=template&id=b2dace6e&"
import script from "./ModifierItem.vue?vue&type=script&lang=js&"
export * from "./ModifierItem.vue?vue&type=script&lang=js&"
import style0 from "./ModifierItem.vue?vue&type=style&index=0&id=b2dace6e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports